import { useEffect, useState } from "react";
import { ToolboxIcon } from "../../../icons/toolboxIcon";
import { useServiceCarStore } from "../../../store/serviceCarStore";
import { Button } from "../../../components/ui/Button";
import { Dialog, DialogContent } from "../../../components/ui/Modal";
import { useNavigate } from "react-router-dom";

export const BookingInitButton = ({ initBookingFlow, disabled }) => {
  // LOCAL STATE:
  const [openDriversModal, setOpenDriversModal] = useState(false);

  // DATA:
  const { carInfo } = useServiceCarStore();

  // LOCAL VARIABLES:
  const navigate = useNavigate();

  // FETCH DATA:

  // USE EFFECTS:
  useEffect(() => {
    if (carInfo.plateno === undefined) {
      navigate(-1);
    }
  }, [carInfo, navigate]);

  // HANDLERS & FUNCTIONS
  const handleNewService = () => {
    if (carInfo.actions.find((item) => item.name === "booking").enabled) {
      initBookingFlow();
    } else setOpenDriversModal(true);
  };

  return (
    <>
      <Button
        className={
          `rounded-full items-center ${ disabled ? 'lg:border lg:border-mildgrey' : 'lg:border lg:border-[#A5A5A5]'} flex gap-2 py-2 px-5`
        }
        disabled ={disabled}
        onClick={handleNewService}
      >
        <ToolboxIcon className={`max-lg:hidden ${disabled ? "stroke-fadedgrey" : "stroke-[#070707]"}`} />
        <p className={`text-label ${disabled && 'text-fadedgrey'} max-lg:text-[#D4002A]`}>Νέο Ραντεβού</p>
      </Button>

      {/* BUSSINESS RULE: A client cannot book a service if no drivers are set to the specific car */}
      {/* Dialog shows on new service button clicked and if there are no drivers set in the car. */}
      <Dialog
        open={openDriversModal}
        onOpenChange={(open) => setOpenDriversModal(open)}
      >
        <DialogContent>
          <div className="bg-white rounded-[12px] p-10 gap-6 flex flex-col items-center">
            <h3>Απαιτείται προσθήκη οδηγού</h3>
            <p className="text-body">
              Για να προγραμματίσεις ραντεβού για service, θα πρέπει να
              προσθέσεις τουλάχιστον έναν οδηγό στο αυτοκίνητο.
            </p>
            <Button
              onClick={() => {
                setOpenDriversModal(false);
              }}
              className={"rounded-[6px] bg-[#D4002A] py-3 px-10 text-white h6"}
            >
              Κλείσιμο
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
